import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { Lead, PageRequest } from '@models/models';
import { MessageService } from '@services/helpers/message-service/message.service';
import { LeadsDataServiceProvider } from '@services/lead/leads.data.service';

@Component({
	selector: 'recent-leads-block',
	template: require('./recent-leads-block.html'),
	styles: [require('./recent-leads-block.scss')]
})
export class RecentLeadsBlockComponent implements OnInit {
	@Input() buttonDisabled: boolean;
	@Input() spinningWheelActive: boolean;
	@Output()
	sendEmailModalTrigger: EventEmitter<object> = new EventEmitter<object>();
	@Output()
	editLeadModalTrigger: EventEmitter<object> = new EventEmitter<object>();
	@Output()
	addNewLeadModalTrigger: EventEmitter<void> = new EventEmitter<void>();

	leads: Lead[] = [];
	itemsQuantity: number;
	pagesQuantity: number;
	pageRequest: PageRequest;
	leadForDelete: number;
	private allowedFilters: string[];

	readonly PAGE_REQUEST_DEFAULT: PageRequest = {
		paging: {
			pageNumber: 0,
			pageSize: 10
		},
		sortCriteria: {
			fieldName: 'createdAt',
			sortAscending: false
		},
		search: '',
		filter: 'open'
	};

	constructor(
		private leadsDataService: LeadsDataServiceProvider,
		private messageService: MessageService,
		private location: Location
	) {}

	ngOnInit() {
		this.pageRequest = this.PAGE_REQUEST_DEFAULT;
		this.configureCommunicationAdapter();
		this.getData();
	}

	addNew(): void {
		this.addNewLeadModalTrigger.emit();
	}

	private getData(): void {
		this.leadsDataService
			.getLeadsOnPage(this.pageRequest, false)
			.subscribe(
				data => this.successGetData(data),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	updateData(pageRequest: PageRequest) {
		this.pageRequest = pageRequest;
		this.leadsDataService
			.getLeadsOnPage(pageRequest, false)
			.subscribe(
				data => this.successGetData(data),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	paginationToDefaults() {
		this.pageRequest = this.PAGE_REQUEST_DEFAULT;
		delete this.pageRequest.paging.searchToken;
		this.getData();
	}

	showLead(id: number): void {
		this.location.go(`leads/view/${id}`);
	}

	showSendEmailModal(id, primaryContact): void {
		this.sendEmailModalTrigger.emit({ leadId: id, data: primaryContact });
	}

	showEditLeadModal(index: number): void {
		this.editLeadModalTrigger.emit(this.leads[index]);
	}

	archiveLead(id: number): void {
		this.leadsDataService.archiveLead(id).subscribe(
			() => {
				this.messageService.showToaster('s_5', 'lead');
				this.updateModel(true);
				this.updateShootsModel(true);
				this.updateGraphsModel(['leads', 'shoots', 'payments']);
			},
			error => {
				const { errorMessage } = error.error;
				if (errorMessage.includes('Lead contains invoices.')) {
					this.messageService.showToaster('e_4', 'lead');
				} else {
					this.messageService.showDefaultErrorMessage(error);
				}
			}
		);
	}

	showDeleteModal(id: number): void {
		this.leadForDelete = id;
		$('#deleteLeadModal').modal('show');
	}

	private successGetData(data) {
		this.pageRequest.paging.searchToken = data.searchToken;
		this.itemsQuantity = data ? data.totalSize : 0;
		this.pagesQuantity = Math.ceil(
			this.itemsQuantity / this.pageRequest.paging.pageSize
		);
		this.leads = JSON.parse(JSON.stringify(data.items));
		this.allowedFilters = data.sortingFields;
	}

	isFilterAllowed(filter: string) {
		if (!this.allowedFilters) {
			return false;
		}

		return this.allowedFilters.includes(filter);
	}

	orderByField(filter: string) {
		if (this.pageRequest.sortCriteria.fieldName === filter) {
			this.pageRequest.sortCriteria.sortAscending = !this.pageRequest
				.sortCriteria.sortAscending;
		} else {
			this.pageRequest.sortCriteria.fieldName = filter;
			this.pageRequest.sortCriteria.sortAscending = false;
		}
		this.pageRequest.paging.pageNumber = 0;

		this.getData();
	}

	private updateModel(resetPagination: boolean): void {
		if (resetPagination) {
			this.paginationToDefaults();
		} else {
			this.getData();
		}
	}

	updateShootsModel(resetPagination: boolean): void {
		window.snCommunicationAdapter.callMethod(
			'updateShootsModel',
			resetPagination
		);
	}

	updatePaymentsModel(resetPagination: boolean): void {
		window.snCommunicationAdapter.callMethod(
			'updateUpcomingPaymentsModel',
			resetPagination
		);
	}

	private updateGraphsModel = function(tabs) {
		window.snCommunicationAdapter.callMethod('updateGraphsModel', tabs);
	};

	private configureCommunicationAdapter(): void {
		window.snCommunicationAdapter.registerMethod(
			'updateRecentLeadsModel',
			this.updateModel.bind(this)
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/dashboard/recent-leads-block/recent-leads-block.ts